export default "__VITE_ASSET__C2$ljscn__ 200w, __VITE_ASSET__pa9FsUdr__ 400w, __VITE_ASSET__BZ9bUvcT__ 600w";